export const HomeMenuContent = {
  heading: "OUR MENU",
  text: `Savor a multi-cuisine spread where <strong>authentic recipes</strong> meet <strong>premium-quality ingredients</strong>. From <strong>Indian and Tandoor specialties</strong> to <strong>Chinese and Continental favorites</strong>, every dish is prepared fresh with true flavors and uncompromised taste.`,
  buttonText: "View Menu",
  sideImage: "./images/selectedDal.jpeg",
  video: "./images/foodVideo.mp4",
};
